import { useQuery } from "@tanstack/react-query";
import { FinancialDocument } from "../../../common/types/financialDocument";
import { getFinancialDocumentFile } from "../../../lib/financialDocument";
import { financialDocumentFileQueryKeys } from "../lib";

export function useFinancialDocumentFileQuery(
    financialDocument: FinancialDocument,
) {
    return useQuery({
        queryKey: financialDocumentFileQueryKeys.file(financialDocument.id),
        queryFn: () => getFinancialDocumentFile(financialDocument.id),
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        // file content doesn't change so makes sense to cache it
        // on the other hand keeping it in memory for too long
        // could have negative impact on performance if someone opens many files
        staleTime: 5 * 60 * 1000,
    });
}
